import exportChat from './export.json'
import feedback from './feedback.json'
import _chat from './index.json'
import liveAgent from './liveAgent.json'
import settings from './settings.json'
import translate from './translate.json'

const chat = {
    ..._chat,
    export: exportChat,
    feedback,
    liveAgent,
    settings,
    translate,
}

export default chat
